import dataPeriRiva from "../../../../src/data/periprocedureel-beleid-rivaroxaban.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataPeriRiva,
  BasicCollapse,
  React
};